import { useMutation } from "@apollo/client"
import { checkStorageUsage, saveToIndexedDB } from "../utils/indexedDb"
import { useStorageContext } from "../contexts/StorageContext"

const useMutationHook = (mutation: any, options: any = {}) => {
    const { setStorageWarning, setStorageCritical } = useStorageContext()
    const [mutateFunction, { data, error, loading }] = useMutation(mutation, options)

    const enhancedMutate = async (variables: any) => {
        const isOnline = await checkConnectivity() // Check network status
        if (isOnline) {
            try {
                // If online, perform the mutation
                return await mutateFunction({ variables })
            } catch (err) {
                console.error("Mutation failed:", err)
                throw err
            }
        } else {
            // If offline, save the mutation to IndexedDB
            await saveToIndexedDB(mutation, variables)
            const storageStatus = await checkStorageUsage()

            if (storageStatus === "critical") {
                setStorageCritical(true)
            } else if (storageStatus === "warning") {
                setStorageWarning(true)
            }

            console.log("Mutation saved for later execution.")
            return true
        }
    }

    return [enhancedMutate, { data, error, loading }]
}
const checkConnectivity = async () => {
    if (!navigator.onLine) return false
    return true
}

export default useMutationHook
